import {config, http} from './__http';

export default {

    getBranchOptions(branches, params) {
        http.get(config.baseUrl()+'/branch').then(response => {
            branches(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    // getBanners(banners, params) {
    //     http.get(config.baseUrl()+'/banner', params).then(response => {
    //         banners(response.data);
    //     }).catch(e => {
    //         console.error(e);
    //     });
    // },
    getBranch(branch, id) {
        http.get(config.baseUrl()+'/branch/'+id).then(response => {
            branch(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    updateBranch(branch, params) {
        http.put(config.baseUrl()+'/branch/'+params.Id, params).then(response => {
            branch(response.data)
        }).catch(e => {
            branch(e.response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/Branch.js